import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import StaffTakeoverMessage from '@bibliocommons/shared-staff-takeover-message';
import { currentUserSelector } from '../selectors/AuthSelector';

export class StaffTakeoverContainer extends BcReactComponent {
  render() {
    if (this.props.name && this.props.showStaffTakeover) {
      return (<StaffTakeoverMessage {...this.props} />);
    }
    return (<noop />);
  }
}

StaffTakeoverContainer.propTypes = {
  name: PropTypes.string,
  showStaffTakeover: PropTypes.bool
};

const mapStateToProps = (state) => {
  const currentUser = currentUserSelector(state);
  return {
    name: currentUser && currentUser.get('name'),
    showStaffTakeover: currentUser && currentUser.get('staffTakeover')
  };
};

export default connect(mapStateToProps)(StaffTakeoverContainer);



// WEBPACK FOOTER //
// ./app/containers/StaffTakeoverContainer.jsx